import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

const StudentProfile = () => {
  const { id } = useParams();
  const [student, setStudent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [editMode, setEditMode] = useState(false);

  const [classes, setClasses] = useState([]);
  const [sections, setSections] = useState([]);

  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    fatherName: '',
    motherName: '',
    phoneNo: '',
    phoneNo2: '',
    email: '',
    gender: '',
    dob: '',
    age: '',
    state: '',
    city: '',
    address: '',
    class: '',
    section: '',
    rollNo: '',
    session: '',
    previousYearResult: '',
  });

  useEffect(() => {
    const fetchStudent = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/students/getStudents/${id}`);
        const data = response.data;

        setStudent(data);

       setFormData({
  ...data,
  dob: data.dob ? new Date(data.dob).toISOString().split('T')[0] : '',
  class: typeof data.class === "object" ? data.class._id : data.class,
  section: typeof data.section === "object" ? data.section.sectionName : data.section,
  session: data.session?._id || data.session || '',
});

        setLoading(false);
      } catch (err) {
        setError(err.response?.data?.message || err.message);
        setLoading(false);
      }
    };

    fetchStudent();
  }, [id]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
  ...prev,
  [name]: value
}));

    // When class changes load sections
    if (name === "class") {
      loadSections(value);
    }
  };

 const loadSections = async (className) => {
  try {

    const res = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/api/sections/${className}/getSectionsByClassName`,
      {
        params: {
          sessionId: formData.session
        }
      }
    );

    setSections(res.data);

  } catch (err) {
    console.log(err);
  }
};

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.put(`${process.env.REACT_APP_API_BASE_URL}/api/students/updateStudent/${id}`, formData);

      alert('Student updated successfully!');
      setEditMode(false);

      const refreshed = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/students/getStudents/${id}`);
      setStudent(refreshed.data);
    } catch (err) {
      setError(err.response?.data?.message || err.message);
    }
  };

  if (loading) return <div className="text-center mt-20 text-gray-600 font-medium">Loading...</div>;
  if (error) return <div className="text-red-500 text-center mt-20 font-medium">Error: {error}</div>;

  return (
    <div className="max-w-6xl mx-auto p-8 bg-white rounded-xl shadow-lg">
      <h1 className="text-4xl font-bold mb-8 text-center text-gray-800">Student Profile</h1>

      {/* EDIT MODE */}
      {editMode && (
        <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {Object.keys(formData)
            .filter((key) => !['_id', '__v', 'image', 'password'].includes(key))
            .map((key) => (
              <div key={key} className="flex flex-col">
                <label className="text-gray-700 font-medium mb-2">
                  {key.charAt(0).toUpperCase() + key.slice(1).replace(/([A-Z])/g, ' $1')}:
                </label>

                {/* CLASS DROPDOWN */}
                {key === 'class' ? (
                  <select
                    name="class"
                    value={formData.class}
                    onChange={handleInputChange}
                    className="border border-gray-500 rounded-lg px-4 py-2"
                  >
                    <option value="">Select Class</option>
                    {classes.map((cls) => (
                      <option key={cls._id} value={cls.className}>
  {cls.className}
</option>
                    ))}
                  </select>
                ) : key === 'section' ? (
                  /* SECTION DROPDOWN */
                  <select
                    name="section"
                    value={formData.section}
                    onChange={handleInputChange}
                    className="border border-gray-500 rounded-lg px-4 py-2"
                  >
                    <option value="">Select Section</option>
                    {sections.map((sec) => (
                     <option key={sec.sectionName} value={sec.sectionName}>
  {sec.sectionName}
</option>
                    ))}
                  </select>
                ) : (
                  <input
                    type={key === 'dob' ? 'date' : 'text'}
                    name={key}
                    value={formData[key]}
                    onChange={handleInputChange}
                    className="border border-gray-500 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 transition"
                    disabled={['phoneNo', 'phoneNo2'].includes(key)}
                  />
                )}
              </div>
            ))}

          <div className="md:col-span-2 flex justify-end mt-4">
            <button
              type="submit"
              className="bg-blue-600 text-white rounded-lg px-6 py-3 font-semibold hover:bg-blue-500 transition"
            >
              Save Changes
            </button>
          </div>
        </form>
      )}

      {/* VIEW MODE */}
      {!editMode && (
        <div>
          <div className="flex justify-center mb-8">
            <div className="text-center">
              <img
                src={student.image || '/images/user.png'}
                alt={`${student.firstName} ${student.lastName}`}
                className="rounded-xl shadow-xl w-48 h-48 object-cover border border-gray-200 mx-auto"
              />
              <h2 className="mt-4 text-2xl font-semibold text-gray-800">
                {student.firstName} {student.lastName}
              </h2>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {Object.entries(student).map(([key, value]) => {
              if (['_id', '__v', 'image', 'password'].includes(key)) return null;
              if (typeof value === 'object' && value !== null) return null;

              let displayValue = value;
              if (key === 'class') displayValue = value?.className || value;
              if (key === 'section') displayValue = value?.sectionName || value;
              if (key === 'session') displayValue = value?.name || value;
              if (key === 'dob') displayValue = value ? new Date(value).toLocaleDateString() : 'N/A';

              return (
                <div
                  key={key}
                  className="bg-white p-4 rounded-xl shadow hover:shadow-lg transition flex flex-col"
                >
                  <span className="font-medium text-gray-700 mb-2">
                    {key.charAt(0).toUpperCase() + key.slice(1).replace(/([A-Z])/g, ' $1')}
                  </span>
                  <span className="text-gray-900 font-semibold">{displayValue || 'N/A'}</span>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {!editMode && (
        <div className="mt-8 flex justify-center">
          <button
           onClick={async () => {
  try {

    // 1️⃣ Get all classes
    const classRes = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/api/classes/getClasses`
    );

    setClasses(classRes.data);

    // 2️⃣ Get sections for student's class
    if (formData.class) {

      const secRes = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/sections/${formData.class}/getSectionsByClassName`,
        {
          params: {
            sessionId: formData.session
          }
        }
      );

      setSections(secRes.data);
    }

    // 3️⃣ open edit mode
    setEditMode(true);

  } catch (err) {
    console.error(err);
  }
}}
            className="bg-yellow-500 text-white rounded-xl px-8 py-3 font-semibold hover:bg-yellow-400 transition flex items-center space-x-2"
          >
            <i className="fas fa-edit"></i>
            <span>Edit Profile</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default StudentProfile;